import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';

export function RequireAuth({
  children,
  allowMustChange = false,
}: {
  children: ReactNode;
  allowMustChange?: boolean;
}) {
  const { session, profile } = useAuth();
  if (!session) return <Navigate to="/login" replace />;
  if (profile?.must_change_password && !allowMustChange) {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { profile } = useAuth();
  if (profile?.role !== 'admin') return <Navigate to="/" replace />;
  return <>{children}</>;
}
